export default {
  name: 'env',
  api: 'https://backend.reservationslab.com/',
  backendUrl: 'https://backend.reservationslab.com/',
  ospUrl: 'https://api.onestopparking.com/',
  googleRecaptcha: '6LcQlIQlAAAAALtOLoiNZkUcdOJJycfJ1ZO68MkB',
  googleKey: 'AIzaSyDCLTka5wKl7sd6XqitBn4TnW9-jZd-3r0',
  parkingOtaUrl: 'https://reservationslab.com'
}
